import { DEFAULT_USER_DISPLAY_NAME } from '../constants/defaultUserDisplayName';
import { IChatHeader } from '../types/chatHeader';

export type TChatHeaderTitle = {
  primaryText: string;
  secondaryText?: string;
};

export const getChatHeaderTitle = (header?: IChatHeader): TChatHeaderTitle => {
  if (!header) {
    return {
      primaryText: DEFAULT_USER_DISPLAY_NAME,
    };
  }

  const { primaryText, secondaryText } = header.title;

  return {
    primaryText: primaryText || DEFAULT_USER_DISPLAY_NAME,
    secondaryText: secondaryText || undefined,
  };
};
